import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { OperatorUser } from './operator-user.model'
import { LocalStorageService } from './local-storage.service';

/**
 * The resolve method here activates when app navigates from signup to vessel-reg, providing the OperatorUser object of the newly signed up user.
 */
@Injectable({
  providedIn: 'root',
})
export class VesselRegResolverService  {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<OperatorUser|never> {
    const username = route.paramMap.get('username')!.toLowerCase();

    return new Promise<OperatorUser>((resolve) => {
        LocalStorageService.local_storage.get('user-' + username).then((doc: any) => {
            resolve(OperatorUser.transformAnonymous(doc.userInfo));
        });
    });
  }
}